import { useState } from 'react';
import { useI18n } from 'Hooks/useI18n';
import { DynamicVariablesModal } from 'Components/organisms/DynamicVariablesModal';
import './styles.scss';

/**
 * Opens the dynamic variable reference modal. Rendered inside the side-panel pills that
 * accept `{{...}}` placeholders (Custom Message, Prepend Custom Message, Additional
 * Context, Message Title, Instructions). Owns its own open/close state so every pill gets
 * the same button without threading modal state through the pill props.
 */
export const DynamicVariablesButton = () => {
    const [showDynamicVariablesModal, setShowDynamicVariablesModal] = useState(false);
    const { t } = useI18n();

    return (
        <>
            <button
                type="button"
                className="btn side-panel__dynamic-variables-button"
                onClick={() => setShowDynamicVariablesModal(true)}
            >
                {t('DYNAMIC_VARIABLES_MODAL_TITLE')}
            </button>
            <DynamicVariablesModal
                show={showDynamicVariablesModal}
                onClose={() => setShowDynamicVariablesModal(false)}
            />
        </>
    );
};
